import {
  Button,
  LoadingOverlay,
  Modal,
  Text,
  TextInput
} from "@marketplace/ui";
import { useAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { bclProductModalAtom } from "../../atoms/integration-product-modal-atom";
import { useBclProductForm } from "../../hooks/forms/use-bcl-product-form";

export const BclProductModal = () => {
  const { t } = useTranslation("product", {
    keyPrefix: "integrationProductListPage.bclModal"
  });

  const [{ visible: opened, data: modalData }] = useAtom(bclProductModalAtom);
  const resetBclModal = useResetAtom(bclProductModalAtom);

  const productId = modalData?.lampu_product_id ?? "";
  const onClose = resetBclModal;

  const { formMethods, onSubmit, isPending, isLoadingDetail } =
    useBclProductForm({
      productId,
      onSuccess: onClose
    });

  const {
    register,
    formState: { errors },
    reset
  } = formMethods;

  // Reset form when modal closes
  useEffect(() => {
    if (!opened) {
      reset();
    }
  }, [opened, reset]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text type="heading" weight="semibold">
          {t("title")}
        </Text>
      }
      size={610}
      classNames={{
        header: "!p-6",
        body: "!p-6 !pt-0"
      }}
    >
      <LoadingOverlay visible={isLoadingDetail} />
      <form onSubmit={onSubmit}>
        <div className="flex flex-col gap-4">
          {/* BCL Product ID */}
          <TextInput
            {...register("product_id")}
            size="lg"
            label={t("labels.productId")}
            placeholder={t("placeholders.productId")}
            error={errors.product_id?.message}
            disabled={isPending}
            withAsterisk
          />

          {/* Action Buttons */}
          <div className="flex justify-end gap-x-[14px]">
            <Button
              variant="secondary"
              onClick={onClose}
              disabled={isPending}
              className="w-[128px]"
            >
              {t("buttons.discard")}
            </Button>
            <Button
              variant="primary"
              type="submit"
              loading={isPending}
              className="w-[128px]"
            >
              {t("buttons.submit")}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};
